import { ReadOnlyMode, WriteMode } from "components/AnalysisRenderMode";

export default function RadioGroup(props) {
    const { id, name, value, label, options, required, onChange, inline = true, meta } = props;

    const hasError = meta && meta.touched && meta.error;

    const selectedOption = options.find((option) => option.value === value);

    return (
        <div className={`Field${hasError ? " has-error" : ""}`}>
            <label className="Field-label">
                {label}
                <WriteMode>
                    {required && <sup className="required">*</sup>}
                </WriteMode>
            </label>
            <WriteMode>
                <div className={`Radio_group${inline === true ? " Radio_group--inline" : ""}`}>
                    {options.map((option) => {
                        const inputId = `${id || name}.${option.value}`;
                        return (
                            <label key={option.value} className="Radio" htmlFor={inputId}>
                                <input className="Radio-input" type="radio" id={inputId} value={option.value} checked={value === option.value} onChange={onChange} />
                                <span className="Radio-label">{option.text}</span>
                            </label>
                        );
                    })}
                </div>
            </WriteMode>
            <ReadOnlyMode>
                <div className="u-mt-sm u-mb-sm">
                    <span>{selectedOption?.text || 'No option selected'}</span>
                </div>
            </ReadOnlyMode>
            {hasError && (
                <small id={`${id || name}-error`} className="Field-error">
                    {meta.error}
                </small>
            )}
        </div>
    );
};
